"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssessmentItemsFromAttempt = void 0;
/**
 * Return a list of assessment template items from an attempt list
 */
var getAssessmentItemsFromAttempt = function (assessmentTemplate, attempt) { return assessmentTemplate.items.filter(function (item) { return attempt.hasItemResponse(item); }); };
exports.getAssessmentItemsFromAttempt = getAssessmentItemsFromAttempt;
